import styled from 'styled-components'

export const Container = styled.div`
  max-width: 450px;
  width: 100%;
  margin: 30px auto 0;
`
export const Content = styled.div`
  padding: 21px 10px 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`
export const ValueContent = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
`
export const ButtonWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;

  > * {
    margin: 0 0.5rem;
  }
`
export const WrapText = styled.div`
  margin-left: 5px;
`
